import React from 'react';
import ReactDOM from 'react-dom';
import AppWithPersistor from './App';

ReactDOM.render(<AppWithPersistor />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js